import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Button,Typography } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import { openDrawer } from './../../../store/slice/MenuSlice';
import ManageProductsProduct from '../action/manageProducts/ManageProductsProduct';
import PharmaorderInfo from '../PharmaorderInfo';
import PharmaorderInfoImpl from '../PharmaorderInfoImpl';
import { setProductDashboardProductList } from 'store/slice/PharmaSlice';
import { deleteInfo } from 'store/slice/HeaderSlice';
import { setPharmaorderSubmitorderModal } from 'store/slice/PharmaSlice';

import ProductDashboard from 'components/product/ProductDashboard';
import { useNavigate } from "react-router-dom";
import {setEditOrderStory} from 'store/slice/AppSlice';
import RemarkListPage from 'components/remark/page/RemarkListPage';

export default function PharmaorderPageEditProduct() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { productList,productDashboard } = useSelector((state) => state.pharmaslice);
    const { pharmaorderObj, submitorderModalOpen } = useSelector((state) => state.pharmaslice.pharmaorderDashboard);
    const { exchange } = useSelector((state) => state.headerslice);
    const {showEdit} = useSelector((state) => state.pharmaslice.productDashboard);

    
    useEffect(() => {

        let index = exchange.map(obj => obj.id).indexOf("001");
        if (index > -1) {
            dispatch(deleteInfo("001"));
            navigate("/pharmaorderpage")
        }
    }, [submitorderModalOpen])

    useEffect(() => {
        //dispatch(openDrawer(false));
        dispatch(
            setProductDashboardProductList(
                productList.filter(obj => obj.orderid == pharmaorderObj.id)
            ))

    }, []);

    const showOrderReview = () => {
        dispatch(setEditOrderStory({ // Initialize the add order story state
            title: "Order Review",
            description: "Order Review",
            currentState: "ORDER_REVIEW",
        }));
    }

    const handleSubmitOrder = () => {
        dispatch(setPharmaorderSubmitorderModal(true));
    }
    return (
        <Grid container direction="row" sx={{ width: '100%', backgroundColor: 'secondary.lighter'}} >
            <Grid lg={12} >
                <PharmaorderInfoImpl/>
            </Grid>
            {/* {pharmaorderObj.comment!==undefined && pharmaorderObj.comment!=="" &&
            <Grid lg={12} sx={{}}>
                <Typography variant="h5" gutterBottom> Refer Back Comments:<Typography variant="h6" color="primary.700" gutterBottom>  
                    {pharmaorderObj.comment}
                </Typography>
                </Typography>
                
            </Grid>
        } */}
            <Grid lg={12} sx={{}}>
                <ProductDashboard />
            </Grid>
            {/* <Grid lg={4} sx={{pl:2,  height: '100%', overflowY: 'auto',  pl:1, borderRadius: 1 }}>
                <Grid container direction="row" sx={{ width: '100%', p:1, backgroundColor:'secondary.100' }}>
                <RemarkListPage maxHeight="50vh" sx={{p:2,}}/>
                </Grid>
            </Grid> */}
            {!showEdit && (<Grid lg={12} xs={12} item sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", width: "100%", mt: 2 }}>
                <Button
                    variant="contained"
                    onClick={() => showOrderReview()}
                    disabled={productDashboard.productList.length==0}
                    endIcon={<ArrowForwardIcon />}
                    sx={{
                        '&.Mui-disabled': {
                            backgroundColor: 'secondary.400',
                            color: 'primary.contrastText',
                            opacity: 1,
                        },
                    }}
                >
                    Order Review
                </Button>
            </Grid>)}
            
        </Grid>

    )

}